<script>
  import {fade} from "svelte/transition";

  export let fullwidth=true;
</script>

{#if fullwidth}
<style>
.page{
  overflow: scroll;
  width: innerWidth;
  padding: 40px;  
  padding-top: 20px;
  
}
@media only screen and (max-width: 600px) {
  .page{
    padding: 10px;
  }
}
</style>
{:else}
<style>
.page{
  padding: 40px;
  margin: auto;
  max-width: 1200px;
}
@media only screen and (max-width: 600px) {
  .page{
    padding: 10px;
  }
}

</style>
{/if}

<div class="page">
  <slot></slot>
</div>